module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_s90@2x-7d19c431cacbaf7d9d3bc25d56cf6333.png";